export default __webpack_public_path__ + "static/media/PROCESS_STEP1_1.f3b31916.png";